import type { MenuItem } from 'primevue/menuitem'
import { acceptHMRUpdate, defineStore } from 'pinia'
import { isArrayWithData } from '@/utils/array/is-array-with-data'

export const useBreadcrumbStore = defineStore('breadcrumb', {
  state: () => ({
    isVisible: true,
    crumbs: <MenuItem[]>[],
  }),

  actions: {
    /**
     * Set the visibility of the breadcrumb.
     * @param {boolean} visible A true or false value
     */
    setVisible(visible: boolean) {
      this.isVisible = visible
    },
    /**
     * Pushes a new menu item to the breadcrumb.
     * @param {MenuItem} item The new menu item
     */
    push(item: MenuItem) {
      if (isArrayWithData(this.crumbs)) {
        const lastCrumb = [...this.crumbs].pop()

        if (lastCrumb && lastCrumb.label === item.label) {
          return
        }
      }

      this.crumbs.push(item)
    },
    /**
     * Pops the last breadcrumb menu item off the array.
     */
    pop() {
      this.crumbs.pop()
    },
    /**
     * Clears the the breadcrumb causing it to be hidden due to no items in the array.
     */
    resetBreadcrumbs() {
      this.crumbs = []
    },
    /**
     * Overrides the crumbs to the passed array.
     * @param {MenuItem[]} items The array of menu items.
     */
    set(items: MenuItem[]) {
      this.crumbs = items
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useBreadcrumbStore, import.meta.hot))
}
